/**
 * Image container for all images that aren't BG images
 * Scales and transforms images appropriately to make them fit their parent container
 */
import React from 'react';

const ImageContainer = ({ src, alt, extraClasses }) => {
  return (
    <div className="relative w-full h-full overflow-hidden flex justify-center items-center">
      <div className="absolute inset-0">
        <img
          src={src}
          alt={alt}
          className={"w-full h-full object-cover " + extraClasses}
        />
      </div>
    </div>
  );
};

export default ImageContainer;
